import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.date.now";
import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.date.now";
import _defineProperty from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import _typeof from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
import store from '@/store';
import vue from 'vue';
import { Message } from 'element-ui';
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (_typeof(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{([ymdhisa])+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}
// 培训课程树
export function courseTree(data) {
  var result = [];
  data.forEach(function (item) {
    if (item.parentId === 0) {
      // 判断是否为顶层节点
      var parent = _objectSpread({
        // 转换成el-Cascader可以识别的数据结构
        key: item.id,
        value: item.id,
        label: item.categoryName
      }, item);
      if (item.trainCategoryInfoResList && item.trainCategoryInfoResList.length > 0) {
        parent.children = getchilds(item.id, item.trainCategoryInfoResList); // 获取子节点
      }
      result.push(parent);
    }
  });
  return result;
}
function getchilds(id, array) {
  var childs = [];
  array.forEach(function (item) {
    if (item.parentId === id) {
      if (item.trainCategoryInfoResList && item.trainCategoryInfoResList.length > 0) {
        item.children = item.trainCategoryInfoResList;
      }
      childs.push(_objectSpread({
        key: item.id,
        value: item.id,
        label: item.categoryName
      }, item));
    }
  });
  childs.forEach(function (item) {
    var childscopy = getchilds(item.value, item.children || []); // 递归获取子节点
    if (item.children && item.children.length > 0) {
      item.children = childscopy;
    }
  });
  return childs;
}
/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}

/**
 * 获取昨天时间
 * @returns {string}
 */
export function getYesterday() {
  var day1 = new Date();
  day1.setTime(day1.getTime() - 24 * 60 * 60 * 1000);
  var s1 = day1.getFullYear() + '-' + (day1.getMonth() + 1 >= 10 ? day1.getMonth() + 1 : '0' + (day1.getMonth() + 1).toString()) + '-' + (day1.getDate() >= 10 ? day1.getDate() : '0' + day1.getDate().toString());
  return s1;
}

/**
 * 获取本周时间区间
 * @returns {array}
 */
export function getThisWeek() {
  var date = new Date();
  var zero = new Date(date.getFullYear(), date.getMonth(), date.getDate(), '00', '00', '00');
  var full = new Date(date.getFullYear(), date.getMonth(), date.getDate(), '23', '59', '59');
  var today = date.getDay();
  var stepSunDay = -today + 1;
  if (today === 0) {
    stepSunDay = -7;
  }
  var stepMonday = 7 - today;
  var monday = new Date(zero.getTime() + stepSunDay * 24 * 3600 * 1000);
  var sunday = new Date(full.getTime() + stepMonday * 24 * 3600 * 1000);
  return [monday, sunday];
}

/**
* 获取本月时间区间
* @returns {array}
*/
export function getThisMonth() {
  var date = new Date();
  var start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), '00', '00', '00');
  start.setDate(1);
  var currentMonth = date.getMonth();
  var nextMonth = ++currentMonth;
  var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1, '23', '59', '59');
  var oneDay = 1000 * 60 * 60 * 24;
  var end = new Date(nextMonthFirstDay - oneDay);
  return [start, end];
}

/**
* 获取当前年份
* @returns {string}
*/
export function getCurrentYear() {
  var date = new Date();
  var year = date.getFullYear();
  return String(year);
}

/**
* 格式化时间（yyyy-MM-dd HH:mm:ss）
* @returns {string}
*/
export function formatDate(dateTime) {
  var date = dateTime;
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  var h = date.getHours();
  h = h < 10 ? '0' + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
}
export function timestampToDate(timestamp) {
  var date = new Date(timestamp);
  var y = date.getFullYear();
  var MM = date.getMonth() + 1;
  MM = MM < 10 ? '0' + MM : MM;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  var h = date.getHours();
  h = h < 10 ? '0' + h : h;
  var m = date.getMinutes();
  m = m < 10 ? '0' + m : m;
  var s = date.getSeconds();
  s = s < 10 ? '0' + s : s;
  return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
}

// 获取当前时间
export function timestampNowDate() {
  var date = new Date();
  var y = date.getFullYear();
  var MM = date.getMonth() + 1;
  MM = MM < 10 ? '0' + MM : MM;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  var h = date.getHours();
  h = h < 10 ? '0' + h : h;
  var m = date.getMinutes();
  m = m < 10 ? '0' + m : m;
  var s = date.getSeconds();
  s = s < 10 ? '0' + s : s;
  return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
}

// 格式化时间
function rangeFormatTime(param) {
  var y = param.getFullYear();
  var m = param.getMonth() + 1;
  var d = param.getDate();
  m = m < 10 ? '0' + m : m;
  d = d < 10 ? '0' + d : d;
  return y + '-' + m + '-' + d + ' ';
}

/**
* 以当前时间为基础，便捷获取时间（最近3月，最近半年，最近一年）
* @param { string } code
* @returns { Object }
*/
export function getDateRange(code) {
  var date = new Date();
  var endTime = rangeFormatTime(date);
  var date1 = Date.parse(date);
  var start = '';
  var end = '';
  var oneDay = 1000 * 3600 * 24;
  switch (code) {
    // 最近3月
    case 'lastThreeMonth':
      start = new Date();
      start.setMonth(start.getMonth() - 3);
      break;
    //  最近半年
    case 'lastHalfYear':
      start = date1 - oneDay * 183;
      break;
    // 最近一年
    case 'lastOneYear':
      start = new Date();
      start.setYear(start.getFullYear() - 1);
      break;
  }
  return {
    startTime: rangeFormatTime(new Date(start)),
    endTime: end ? rangeFormatTime(new Date(end)) : endTime
  };
}

/**
* UTC时间转北京
* @param { string } code
* @returns { string }
*/
export function UTCTime(utc_datetime) {
  function supplement(sty) {
    var stys = sty < 10 ? '0' + sty : sty;
    return stys;
  }
  // 转为正常的时间格式 年-月-日 时:分:秒
  var T_pos = utc_datetime.indexOf('T');
  var Z_pos = utc_datetime.indexOf('Z');
  var year_month_day = utc_datetime.substr(0, T_pos);
  var hour_minute_second = utc_datetime.substr(T_pos + 1, Z_pos - T_pos - 1);
  var new_datetime = "".concat(year_month_day, " ").concat(hour_minute_second);
  // 处理成为时间戳
  timestamp = new Date(Date.parse(new_datetime));
  timestamp = timestamp.getTime();
  // 增加8个小时，北京时间比utc时间多八个时区
  var timestamp = timestamp + 8 * 3600 * 1000;
  // 时间戳转为时间
  var oDate = new Date(timestamp);
  var oTime = "".concat(oDate.getFullYear(), "-").concat(supplement(oDate.getMonth() + 1), "-").concat(supplement(oDate.getDate()), " ").concat(supplement(oDate.getHours()), ":").concat(supplement(oDate.getMinutes()), ":").concat(supplement(oDate.getSeconds()));
  return oTime;
}

/**
* 年-月-日T08:22:25.000+0000转成 年-月-日 08:22:25
* @param { string } val
* @returns { string }
*/
export function timefilters(val) {
  var d = new Date(val);
  var month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
  var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
  var hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
  var min = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
  var sec = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
  var times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
  return times;
}

/**
 * 转换表格树
 * @param list 原始数组
 * @param arr 转换后的数组
 * @param parentId 父id
 */
export function classifyTableTree(list, arr, parentId) {
  list.forEach(function (item) {
    if (selectInParentId(item.parentId, parentId)) {
      item.children = [];
      classifyTableTree(list, item.children, [item.classifyId]);
      if (item.children.length === 0) {
        delete item.children;
      }
      arr.push(item);
    }
  });
}
// 查询父节点
export function selectInParentId(parentId, parentArr) {
  for (var i = 0; i < parentArr.length; i++) {
    if (parentId !== null && parentId === parentArr[i]) {
      return true;
    }
  }
  return false;
}

/**
 * 转换分类下拉树
 * @param list 原始数组
 * @param arr 转换后的数组
 * @param parentId 父id，默认传0
 */
export function classifySelectTree(list, arr, parentId) {
  list.forEach(function (item) {
    if (item.parentId === parentId) {
      var child = {
        parentId: item.classifyId,
        value: item.classifyId,
        // value是给modal的select用的，2者属性不一样
        label: item.classifyName,
        children: []
      };
      classifySelectTree(list, child.children, item.classifyId);
      if (child.children.length === 0) {
        delete child.children;
      }
      arr.push(child);
    }
  });
}

/**
 * 转换部门下拉树
 * @param list 原始数组
 * @param arr 转换后的数组
 * @param parentId 父id，默认传0
 */
export function dept1SelectTree(list, arr, parentId) {
  list.forEach(function (item) {
    if (item.parentId === parentId) {
      var child = {
        key: item.departmentId,
        value: item.departmentId,
        // value是给modal的select用的，2者属性不一样
        label: item.departmentName,
        children: []
      };
      dept1SelectTree(list, child.children, item.departmentId);
      if (child.children.length === 0) {
        delete child.children;
      }
      arr.push(child);
    }
  });
}

/**
 * 转换组织机构下拉树
 * @param list 原始数组
 * @returns {[]}
 */
export function deptSelectTree(list) {
  var arr = [];
  list.forEach(function (item) {
    var child = {
      key: item.departmentId,
      value: item.departmentId,
      // value是给modal的select用的，2者属性不一样
      label: item.departmentName,
      children: item.children || []
    };
    if (child.children !== undefined && child.children.length > 0) {
      child.children = deptSelectTree(item.children);
    }
    if (child.children.length === 0) {
      delete child.children;
    }
    arr.push(child);
  });
  return arr;
}
var inBrowser = typeof window !== 'undefined';
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
export var isIE9 = UA && (UA.indexOf('msie 9.0') > 0 || UA.indexOf('msie 7.0') > 0);

/**
 * 获取明天时间
 * @param val 时分秒
 * @returns String
 */
export function tomorrowTime(val) {
  var tomorrow = new Date();
  tomorrow.setTime(tomorrow.getTime() + 24 * 60 * 60 * 1000);
  return "".concat(tomorrow.getFullYear(), "-").concat(tomorrow.getMonth() + 1, "-").concat(tomorrow.getDate(), " ").concat(val);
}

/**
 * 根据年月获取当月天数
 * @param {year,month} 年份 月份
 * @returns String
 */
export function getDateNumsByMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

/**
 * 格式化演示环境（http://yqwx.ilabeco.com/）附件域名
 * @param {fileUrl} 附件地址
 * https://ysa.imgs.ilabeco.com/group1/M00/00/36/L3F7sWRBBViAXmC4ABN7HKwLkrI331.pdf
 * 转换成
 * https://ysa.imgs.upload.ilabeco.com/group1/M00/00/36/L3F7sWRBBViAXmC4ABN7HKwLkrI331.pdf
 */
export function formatFileUrl(url) {
  /*const env = process.env.NODE_ENV
  if (env !== 'development' && url.includes(':')) {
    const currentP = window.location.href.split(':')[0]
    const beforep = url.split(':')[0]
    url = url.replace(beforep, currentP)
  }*/
  if (!url.startsWith('http://')) return url;
  if (url.includes(':')) {
    var beforep = url.split(':')[0];
    url = url.replace(beforep, 'https');
  }
  if (url.includes('yqwx.jnu.edu.cn/file/group1')) {
    url = url.replace('yqwx.jnu.edu.cn/file/group1', 'yqwx.jnu.edu.cn/api/fileYsAImage/group1');
  }
  if (url.includes('.imgs.ilabeco.')) {
    url = url.replace('.imgs.ilabeco.', '.imgs.upload.ilabeco.');
  }
  return url;
}
export function formatUploadUrl(url) {
  if (url.includes(':')) {
    var currentP = window.location.href.split(':')[0];
    var beforep = url.split(':')[0];
    url = url.replace(beforep, currentP);
  }
  return url;
}
// 维保商城按钮控制
export function ButtonControl() {
  var buttonControl = [];
  if (store.state.permission.projects) {
    store.state.permission.projects.filter(function (item) {
      if (item.permissionKey === 'maintenanceService' && item.visible === '0') {
        buttonControl = item.permissionMS.filter(function (i) {
          return i.permissionKey === 'maintenance';
        })[0].buttons;
      }
    });
  }
  return buttonControl;
}
// 生成uuid
export function getUuid() {
  var s = [];
  var hexDigits = 'abcdefghijklmnopqrstuvwxyz';
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4'; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23];
  var uuid = s.join('');
  return uuid;
}

// 获取当前学校的配置信息
export var getCurrentProInfo = function getCurrentProInfo(v, setting) {
  if (!v || !Object.keys(setting).length) return setting.def;
  var schoolSetting = setting[v];
  if (!schoolSetting) {
    return setting.def;
  }
  return schoolSetting;
};

// 获取文件后缀
export function getSuffix(url) {
  if (!url) return '';
  var arr = url.split('.');
  return arr[arr.length - 1];
}

// 获取当天时间
export function getSameDay() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  month = month < 10 ? '0' + month : month;
  day = day < 10 ? '0' + day : day;
  return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
}
export function getSun(istype, data) {
  var sum = data.reduce(function (res, item) {
    if (item[istype] && Number(item[istype]) > 0) res = res + Number(item[istype]);
    return res;
  }, 0);
  return sum;
}
export function isJson(data) {
  try {
    var jsonData = JSON.parse(data);
    return jsonData;
  } catch (e) {
    return false;
  }
}

// 格式化JSON文件列表
export function formatJsonArray(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  var res = isJson(data) ? JSON.parse(data) : [];
  return Array.isArray(res) ? res : [];
}
export function copyText(text) {
  var textarea = document.createElement('textarea');
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  try {
    var successful = document.execCommand('copy');
    if (successful) {
      Message.success('复制成功！');
    } else {
      Message.error('复制失败，请手动复制');
    }
  } catch (err) {
    Message.error('当前浏览器不支持自动复制，请手动复制');
  }
  document.body.removeChild(textarea);
}

// 显示其它模块
export function showOther(key) {
  var _store$state$user = store.state.user,
    user = _store$state$user === void 0 ? {} : _store$state$user;
  var _user$userInfo = user.userInfo,
    userInfo = _user$userInfo === void 0 ? {} : _user$userInfo;
  var _userInfo$extendConfi = userInfo.extendConfig,
    extendConfig = _userInfo$extendConfi === void 0 ? {} : _userInfo$extendConfi;
  // 需要区分是从 userInfo 还是 extendConfig 里取
  var directKeys = ['showOtherCard', 'showOtherCardNcu'];
  var source = directKeys.includes(key) ? userInfo : extendConfig;
  return "".concat(source[key] || '0') === '1';
}